import { Directive, ElementRef, HostListener, OnDestroy, OnChanges } from '@angular/core';

import { fromEvent } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ShipmentService } from '../shipment.service';

@UntilDestroy()
@Directive({
   selector: '[summaryLink]',
   inputs: [ 'title' ]
})
export class SummaryLinkDirective implements OnDestroy, OnChanges {

   title: string;

   constructor(
      private el: ElementRef,
      public s: ShipmentService
   ) { }

   ngOnChanges() {
      this.s.focused.subscribe( id => {
         if ( id === this.title ) {
            this.el.nativeElement.classList.add( 'active' );
            this.el.nativeElement.scrollIntoView();
         } else {
            this.el.nativeElement.classList.remove( 'active' );
         }
      });

      fromEvent( window, 'scroll' ).pipe(
         map( _ => document.getElementById( this.title )),
         takeWhile( e => !!e ),
         untilDestroyed( this ),
      ).subscribe( e => {
         if ( this.s.focused.getValue() === this.title ) { return; }

         const top = e.offsetTop;
         const bottom = e.offsetTop + e.offsetHeight;
         const yOffset = window.pageYOffset + 100;

         if ( top <= yOffset && bottom >= yOffset ) {
            this.s.focused.next( this.title );
         }
      });
   }

   ngOnDestroy() { }

   @HostListener( 'click' ) onClick() {
      document.getElementById( this.title ).scrollIntoView();
      // const element = document.getElementById( this.title );
      // const y = element.getBoundingClientRect().top + window.pageYOffset - 150;

      // window.scrollTo({ top: y, behavior: 'smooth' });
   }
}
